import template from './filter.html';
export var FilterComponent = {
    template: template,
    bindings: {
        filterModel: '<'
    },
    controller: /** @class */ (function () {
        function FilterComponent($state, $stateParams, FilterService, googleAnalytic) {
            'ngInject';
            this.searchUrl = 'advSearchResults';
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.FilterService = FilterService;
            this.ga = googleAnalytic;
        }
        FilterComponent.prototype.clearAllFilters = function () {
            if (this.$state.current.name === 'searchResults') {
                this.$state.go(this.$state.current, {}, { reload: true });
            }
            else {
                // reset all array-like filter as empty array, keep string-like filter parameter
                var state_1 = Object.assign({}, this.$stateParams);
                var resetAttribute = ['a', 'b', 'c', 'd', 's', 'dc', 'df', 'ds', 'q', 'ii', 'ei'];
                resetAttribute.forEach(function (attr) {
                    state_1[attr] = [];
                });
                state_1[state_1['fft']] = state_1['ff'];
                this.$state.go(this.searchUrl, state_1);
            }
        };
        FilterComponent.prototype.showFilterItems = function (filter) {
            filter.displayNumber = filter.displayNumber ? 0 : 5;
            filter.open = !filter.open;
        };
        FilterComponent.prototype.toggleIncluded = function (stateParam, item) {
            var id = item.id ? item.id + '' : item.name;
            var state = Object.assign({}, this.$stateParams);
            this.FilterService.checkForLandingPageTransition(state);
            if (!state[stateParam]) {
                state[stateParam] = [];
            }
            if (typeof (state[stateParam]) === 'string') {
                state[stateParam] = [state[stateParam]];
            }
            if (Array.isArray(state[stateParam])) {
                var index = state[stateParam].indexOf(id);
                if (index > -1) {
                    state[stateParam].splice(index, 1);
                }
                else {
                    state[stateParam].push(id);
                }
            }
            if (item.hasSubItems) {
                state['s'] = (typeof (state['s']) === 'string') ? [state['s']] : (state['s'] || []);
                if (item.isActive) {
                    item.subItems.forEach(function (sub) {
                        var index = state['s'].indexOf(sub.id + '');
                        if (index > -1) {
                            state['s'].splice(index, 1);
                        }
                    });
                }
                else if (!item.isActive) {
                    item.subItems.forEach(function (sub) {
                        var index = state['s'].indexOf(sub.id + '');
                        if (index === -1) {
                            state['s'].push(sub.id + '');
                        }
                    });
                }
            }
            state['page'] = '1';
            this.$state.go(this.searchUrl, state);
        };
        FilterComponent.prototype.getStateMap = function () {
            var state = Object.assign({}, this.$stateParams);
            this.FilterService.checkForLandingPageTransition(state);
            state['s'] = (typeof (state['s']) === 'string') ? [state['s']] : (state['s'] || []);
            state['c'] = (typeof (state['c']) === 'string') ? [state['c']] : (state['c'] || []);
            state['a'] = (typeof (state['a']) === 'string') ? [state['a']] : (state['a'] || []);
            return state;
        };
        FilterComponent.prototype.toggleCategory = function (category) {
            var _this = this;
            var state = this.getStateMap();
            state['a'] = state['a'].filter(function (attrId) { return _this.FilterService.subCategoryCategoryLookup[_this.FilterService.attributeSubcategoryLookup[parseInt(attrId)]] !== category.id; });
            state['s'] = state['s'].filter(function (subId) { return _this.FilterService.subCategoryCategoryLookup[parseInt(subId)] !== category.id; });
            var index = state['c'].indexOf(category.id + '');
            if (index > -1) {
                state['c'].splice(index, 1);
            }
            else {
                state['c'].push(category.id + '');
            }
            state['page'] = '1';
            this.ga.sendEvent('SearchResultFilter', 'Category', category.name, 1);
            this.$state.go(this.searchUrl, state);
        };
        FilterComponent.prototype.toggleSubcategory = function (category, subCategory) {
            var _this = this;
            var state = this.getStateMap();
            state['a'] = state['a'].filter(function (attrId) { return _this.FilterService.attributeSubcategoryLookup[parseInt(attrId)] !== subCategory.id; });
            var index = state['s'].indexOf(subCategory.id + '');
            if (index > -1) {
                state['s'].splice(index, 1);
            }
            else {
                var parentIndex = state['c'].indexOf(category.id + '');
                if (parentIndex > -1) {
                    state['c'].splice(parentIndex, 1);
                }
                state['s'].push(subCategory.id);
            }
            state['page'] = '1';
            this.ga.sendEvent('SearchResultFilter', 'Subcategory', subCategory.name, 1);
            this.$state.go(this.searchUrl, state);
        };
        FilterComponent.prototype.toggleAttribute = function (category, subCategory, attribute) {
            var state = this.getStateMap();
            var attributeIndex = state['a'].indexOf(attribute.id + '');
            if (attributeIndex > -1) {
                state['a'].splice(attributeIndex, 1);
            }
            else {
                var parentIndex = state['s'].indexOf(subCategory.id + '');
                if (parentIndex > -1) {
                    state['s'].splice(parentIndex, 1);
                }
                state['a'].push(attribute.id);
            }
            state['page'] = '1';
            this.ga.sendEvent('SearchResultFilter', 'Attribute', attribute.name, 1);
            this.$state.go(this.searchUrl, state);
        };
        FilterComponent.prototype.queryIngredients = function (ingredients, text) {
            return text ? ingredients
                .filter(function (item) { return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1; }) : ingredients;
        };
        FilterComponent.prototype.selectIngredient = function (filter, item) {
            if (!item)
                return;
            var state = this.$stateParams;
            this.FilterService.checkForLandingPageTransition(state);
            var filterList = [];
            if (typeof (state[filter['stateParameter']]) === 'string') {
                filterList = [state[filter['stateParameter']]];
            }
            else {
                filterList = state[filter['stateParameter']] || [];
            }
            if (filterList.indexOf(item['id'] + '') === -1) {
                filterList.push(item['id'] + '');
            }
            state[filter['stateParameter']] = filterList;
            this.$state.go(this.searchUrl, state);
        };
        FilterComponent.prototype.clearIngredient = function (filter, item) {
            var state = this.$stateParams;
            this.FilterService.checkForLandingPageTransition(state);
            if (typeof (state[filter['stateParameter']]) === 'string') {
                state[filter['stateParameter']] = [state[filter['stateParameter']]];
            }
            else {
                state[filter['stateParameter']] = state[filter['stateParameter']] || [];
            }
            var index = state[filter['stateParameter']].indexOf(item.id + '');
            if (index > -1) {
                state[filter['stateParameter']].splice(index, 1);
            }
            this.$state.go(this.searchUrl, state);
        };
        return FilterComponent;
    }())
};
//# sourceMappingURL=filter.component.js.map